<template>
  <div
    id="payment-info"
    data-test="payment-info"
    class="payment-info text-center"
    v-bind:style="{ backgroundImage: backgroundUrl }"
  >
    <div class="overlay row d-xs-block d-sm-none"></div>
    <div class="row">
      <div class="col-sm-12">
        <span class="logo">
          <span
            id="logo"
            data-test="logo"
            :alt="'logo ' + merchantDetails.name"
            class="img-logo"
            v-bind:style="{ backgroundImage: logoUrl }"
          ></span>
        </span>
      </div>
    </div>
    <div class="content" data-test="content">
      <div class="row">
        <div class="col-sm-12">
          <h3 :title="'Merchant: ' + merchantDetails.name">
            {{ merchantDetails.name }}
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h2>{{ orderDetails.cartName }}</h2>
          <h1 :title="orderDetails.amount | currency">
            {{ currencySymbol }} {{ orderDetails.amount | currency }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import getSymbolFromCurrency from "currency-symbol-map";
const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "paymentInfo",
  computed: {
    ...paymentNS.mapGetters([
      "orderDetails",
      "merchantDetails",
      "logoUrl",
      "backgroundUrl",
      "cssUrl",
    ]),
    currencySymbol() {
      let symbol = getSymbolFromCurrency(this.orderDetails.currency);
      return !symbol ? this.orderDetails.currency : symbol;
    },
  },
};
</script>
